module.exports = __webpack_public_path__ + "static/media/nodejs-icon.77673814.svg";